






























































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetProvinceList, InsertProvince, UpdateProvinceById, DeleteProvince} from '../../../api/basicDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
@Component
export default class Country extends AbpBase {
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm:any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	created() {
		this.getData()
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
			(this.$refs.form as any).resetFields()
		}
	}
	columns = [
		{
			key: 'provName',
			title: '省名称'
		},
		{
			key: 'provPY',
			title: '拼音助记符'
		},
		{
			key: 'provWB',
			title: '五笔助记符'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	createCounty() {
		this.dialogTitle = '新增省'
		this.dialogForm = {status:true,provPY:'',provWB:''}
		this.dialogFormVisible = true
	}
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.provPY = res1
		this.dialogForm.provWB = res2
	}
	private async getData() {
		this.tableLoading = true
		let res = await GetProvinceList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑省'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}
	async del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteProvince({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增省') {
					let res = await InsertProvince(this.dialogForm)
				} else if (this.dialogTitle === '编辑省') {
					let res = await UpdateProvinceById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})

	}
	rules = {
		provName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		provPY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		provWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	pageChange(val: any){
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/basicDictionary/province/index.vue